import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Title = (props) => {
   const { title = '', overrideDefault  = false } = props;

   return (
      <HelmetProvider>
          <Helmet>
             <title>
                {title}
                {overrideDefault ? '' : ' | RND'}
             </title>
          </Helmet>
      </HelmetProvider>
   );
};

Title.propTypes = {
   title: PropTypes.string,
   overrideDefault: PropTypes.bool,
};

export { Title };